'use client';
import { useEffect, useRef, useState } from 'react';
import { useNavigation } from '@/contexts/NavigationContext';

export default function TopProgressBar() {
  const { isNavigating } = useNavigation();
  const [pct, setPct] = useState(0);
  const [visible, setVisible] = useState(false);
  const slowTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (slowTimer.current) clearTimeout(slowTimer.current);
    if (hideTimer.current) clearTimeout(hideTimer.current);

    if (isNavigating) {
      setVisible(true);
      setPct(0);
      requestAnimationFrame(() => {
        setPct(22);
        slowTimer.current = setTimeout(() => setPct(70), 120);
      });
    } else {
      setPct(100);
      hideTimer.current = setTimeout(() => {
        setVisible(false);
        setPct(0);
      }, 380);
    }

    return () => {
      if (slowTimer.current) clearTimeout(slowTimer.current);
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, [isNavigating]);

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 99999,
        height: 3,
        width: `${pct}%`,
        background: 'linear-gradient(90deg, #6366f1 0%, #818cf8 60%, #a5b4fc 100%)',
        borderRadius: '0 3px 3px 0',
        boxShadow: '0 0 12px 2px rgba(99,102,241,0.55)',
        transition:
          pct === 100  ? 'width 0.22s ease'  :
          pct === 70   ? 'width 1.6s ease'   :
                         'width 0.12s ease',
        pointerEvents: 'none',
      }}
    />
  );
}
